import { ServiceResult } from '../models';
import {
  GetRecipeMenuDiariesRequest,
  RecipeMenuDiary,
  RevertRecipeMenuDiaryActionRequest,
} from '../models/recipe-menu-diary.models';
import ApiService from './api-service';

class RecipeMenuDiaryService extends ApiService {
  private static classInstance: RecipeMenuDiaryService;

  private constructor() {
    super('RecipeMenuDiary');
  }

  public static getInstance(): RecipeMenuDiaryService {
    if (!this.classInstance) {
      this.classInstance = new RecipeMenuDiaryService();
    }
    return this.classInstance;
  }

  public getRecipeMenuDiary(recipeMenuDiaryId: string): ServiceResult<RecipeMenuDiary> {
    return this.get(`${this.persistUrl}/GetRecipeMenuDiary?recipeMenuDiaryId=${recipeMenuDiaryId}`);
  }

  public getRecipeMenuDiarys(request: GetRecipeMenuDiariesRequest): ServiceResult<RecipeMenuDiary[]> {
    return this.post(`${this.persistUrl}/GetRecipeMenuDiarys`, request);
  }

  public revertRecipeMenuDiaryAction(request: RevertRecipeMenuDiaryActionRequest): ServiceResult<undefined> {
    return this.post(`${this.persistUrl}/RevertRecipeMenuDiaryAction`, request);
  }
}

export default RecipeMenuDiaryService;
